import { render, staticRenderFns } from "./SdksList.vue?vue&type=template&id=3712a27e&scoped=true"
import script from "./SdksList.vue?vue&type=script&lang=js"
export * from "./SdksList.vue?vue&type=script&lang=js"
import style0 from "./SdksList.vue?vue&type=style&index=0&id=3712a27e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3712a27e",
  null
  
)

export default component.exports